var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input-textarea',{attrs:{"text":_vm.text},on:{"update:text":function($event){_vm.text=$event}}}),_c('code',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }